import { cn } from '@components/primitives/utilities';

import { Text, TextProps } from '.';

import css from './styles.module.css';

type TextHeadingProps = Omit<TextProps<'h3'>, 'size' | 'as'> & {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
};

export function TextHeading({ className, ...props }: TextHeadingProps) {
  const classes = cn(css.heading, className);
  return <Text as="h3" className={classes} {...props} />;
}
